import { render, staticRenderFns } from "./OffMemory.vue?vue&type=template&id=a868133a&scoped=true"
import script from "./OffMemory.vue?vue&type=script&lang=js"
export * from "./OffMemory.vue?vue&type=script&lang=js"
import style0 from "./OffMemory.vue?vue&type=style&index=0&id=a868133a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868133a",
  null
  
)

export default component.exports